module.exports = __webpack_public_path__ + "static/media/main.8ebf0efb.png";